/* M3 landing page. Vanilla JS, no dependencies.
   Hero gallery, offer selection, buy button, sticky bar, videos, countdown.
   Re-runs on theme editor section loads. */
(function () {
  'use strict';

  var CURRENCY = '$';

  function money(cents) {
    return CURRENCY + (cents / 100).toFixed(2);
  }

  /* ---------- Hero: gallery, offers, buy ---------- */
  function initHero(root) {
    if (!root || root.dataset.lpInit === '1') return;
    root.dataset.lpInit = '1';

    var main = root.querySelector('[data-lp-gallery-main]');
    var thumbs = root.querySelector('[data-lp-thumbs]');
    var imgs = thumbs ? Array.prototype.map.call(thumbs.children, function (b) { return b.dataset.src; }) : [];
    var cur = 0;

    function show(i) {
      if (!main || !imgs.length) return;
      cur = (i + imgs.length) % imgs.length;
      main.src = imgs[cur];
      Array.prototype.forEach.call(thumbs.children, function (b, k) { b.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      thumbs.children[cur].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    if (thumbs) {
      Array.prototype.forEach.call(thumbs.children, function (b, i) { b.addEventListener('click', function () { show(i); }); });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-lp-gallery-arrow]'), function (b) {
      b.addEventListener('click', function () { show(cur + parseInt(b.dataset.lpGalleryArrow, 10)); });
    });

    var atc = root.querySelector('[data-lp-atc]');
    var atcTxt = root.querySelector('[data-lp-atc-text]');
    var err = root.querySelector('[data-lp-atc-error]');
    var offers = root.querySelectorAll('.lp-offer input[type="radio"]');
    var atcLabel = root.dataset.lpAtcLabel || 'BUY NOW';

    function selected() {
      for (var i = 0; i < offers.length; i++) if (offers[i].checked) return offers[i];
      return offers[0];
    }

    function sync() {
      var inp = selected();
      if (!inp) return;
      Array.prototype.forEach.call(root.querySelectorAll('.lp-offer'), function (o) { o.classList.toggle('sel', o.contains(inp)); });
      var price = money(parseInt(inp.dataset.price, 10));
      if (atcTxt) atcTxt.textContent = atcLabel + ' · ' + price;
      if (inp.dataset.imageIndex !== '') show(parseInt(inp.dataset.imageIndex, 10));
      Array.prototype.forEach.call(document.querySelectorAll('[data-lp-sticky-name]'), function (el) { el.textContent = inp.dataset.name; });
      Array.prototype.forEach.call(document.querySelectorAll('[data-lp-sticky-price]'), function (el) { el.textContent = price; });
      if (atc) atc.disabled = inp.dataset.available === 'false';
      var qty = parseInt(inp.dataset.qty || '1', 10);
      Array.prototype.forEach.call(root.querySelectorAll('[data-lp-perk]'), function (p) {
        p.classList.toggle('off', parseInt(p.dataset.minQty || '0', 10) > qty);
      });
    }
    Array.prototype.forEach.call(offers, function (inp) { inp.addEventListener('change', sync); });
    sync();

    function fail(message) {
      atc.disabled = false;
      sync();
      if (err) { err.textContent = message; err.classList.add('is-visible'); }
    }

    if (!atc) return;
    atc.addEventListener('click', function () {
      var inp = selected();
      // Entries are "variantId:qty" (older templates: bare "variantId").
      var ids = inp ? inp.dataset.variantId.split(',').filter(Boolean).map(function (e) { return e.indexOf(':') > -1 ? e : e + ':1'; }) : [];
      if (!ids.length) return fail('This offer is not linked to a product yet.');
      if (err) err.classList.remove('is-visible');
      atc.disabled = true;
      if (atcTxt) atcTxt.textContent = 'ONE SEC…';

      var code = (inp.dataset.code || '').trim();
      var items = ids.map(function (e) { var p = e.split(':'); return { id: parseInt(p[0], 10), quantity: parseInt(p[1], 10) || 1 }; });

      if (root.dataset.lpAfterAdd !== 'cart') {
        // Cart permalink: one hop. Replaces the cart, applies the code, opens checkout.
        var url = '/cart/' + ids.join(',');
        if (code) url += '?discount=' + encodeURIComponent(code);
        window.location.href = url;
        return;
      }

      // Cart page option: add on top of the existing cart, set the code, land on /cart.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); });
      }).then(function () {
        window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart' : '/cart';
      }).catch(function (e) { fail(e.message); });
    });
  }

  /* ---------- Sticky bar: hidden while the buy box is on screen ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-lp-sticky]');
    var buy = document.getElementById('offer');
    if (!bar || !buy || !('IntersectionObserver' in window) || bar.dataset.lpInit === '1') return;
    bar.dataset.lpInit = '1';
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-hidden', entries[0].isIntersecting);
    }, { threshold: 0.2 }).observe(buy);
  }

  /* ---------- Videos ---------- */
  function initVideos(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.lp-vid'), function (w) {
      if (w.dataset.lpInit === '1') return;
      w.dataset.lpInit = '1';
      var v = w.querySelector('video'), b = w.querySelector('.play');
      if (!v || !b) return;
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(document.querySelectorAll('.lp-vid video'), function (o) { if (o !== v) o.pause(); });
        v.controls = true;
        v.play();
        w.classList.add('playing');
      });
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(scope) {
    var t = scope.querySelector('[data-lp-timer]');
    if (!t || t.dataset.lpInit === '1') return;
    t.dataset.lpInit = '1';
    var END = t.dataset.end ? new Date(t.dataset.end) : null;
    if (END && isNaN(END.getTime())) END = null;
    var d = t.querySelector('[data-d]'), h = t.querySelector('[data-h]'), m = t.querySelector('[data-m]'), s = t.querySelector('[data-s]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var end = END || new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1); // evergreen: local midnight
      var sec = Math.max(0, Math.floor((end - now) / 1000));
      var days = Math.floor(sec / 86400);
      d.textContent = pad(days);
      d.parentNode.style.display = days > 0 ? '' : 'none';
      h.textContent = pad(days > 0 ? Math.floor(sec % 86400 / 3600) : Math.floor(sec / 3600));
      m.textContent = pad(Math.floor(sec % 3600 / 60));
      s.textContent = pad(sec % 60);
      if (sec === 0 && END && t.dataset.endedText) t.parentNode.textContent = t.dataset.endedText;
    }
    tick();
    setInterval(tick, 1000);
  }

  function initAll(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-lp-hero]'), initHero);
    initSticky();
    initVideos(scope);
    initCountdown(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
